










import { Vue, Component } from 'vue-property-decorator';
import Mensaje from '@/pantallas/CopilotoVirtual/Mensaje/CopilotoMensaje.vue';

@Component({
  components: { Mensaje },
})
export default class MensajesPantalla extends Vue {}
